const moneyToFloat = require('../functions/moneyToFloat');
const floatToMoney = require('../functions/floatToMoney');
const GlobalAlerts = require('global_alerts');
const Lang = require('lang');

// iniciando valores dos inputs, mas eles serão atualizados
// quando for chamada a funcao updateInputs ao abrir as modais
let percurso = document.getElementById('percurso')
  || document.getElementById('modal-mapa-percurso')
  || document.getElementById('modal-percurso');

let valorKmInput = percurso ? percurso.querySelector('#valorKm') : null;
let kilometragemInput = percurso ? percurso.querySelector('#kilometragem') : null;
let valorInput = percurso ? percurso.querySelector('#valor') : null;
let dataInput = percurso ? percurso.querySelector(percurso.id === 'modal-mapa-percurso' ? '#data-percurso-mapa' : '#data-percurso') : null;
let idInput = percurso ? percurso.querySelector('[name=id]') : null;
let obsInput = percurso ? percurso.querySelector('#obs') : null;
let form = percurso ? valorInput.form : null;
let inputEventControlModalMapa = false;
let inputEventControlModalPercurso = false;

function CalcCourseValue() {
  if (!percurso) {
    return;
  }

  $(dataInput).on('change', handleCalc);
  $(kilometragemInput).on('change', handleCalc);
  $(kilometragemInput).on('keyup', handleCalc);
  valorKmInput.addEventListener('keyup', calculateTotal);
}

const calculateTotal = () => {
  const valorKm = moneyToFloat(valorKmInput.value);
  const km = moneyToFloat(kilometragemInput.value);

  let valor = km * valorKm;

  valor = isNaN(valor) ? '0.00' : floatToMoney(valor.toFixed(2));

  valorInput.value = valor;
  $(valorInput).trigger('change');
};

const calculateValorKmPolitica = () => {
  const id = idInput.value;
  const valorKm = moneyToFloat(valorKmInput.value);
  const km = moneyToFloat(kilometragemInput.value);
  const data = dataInput ? dataInput.value : null;

  if (!km || !data) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: route('app.despesas.calcular-valor-km-politica'),
    dataType: 'json',
    data: { kilometragem: km, data: data, rejectId: id }
  }).done(response => {
    const inputs = response.data;
    valorInput.value = floatToMoney(response.data.valor.toFixed(2));
    $(valorInput).trigger('change');
    valorKmInput.value = response.data.valorKm;
    obsInput.value = response.data.obs;
  }).fail(response => {
    GlobalAlerts.createAndShow({
      title: Lang.get('js/src/classes/gmaps.ops'),
      message: Lang.get('js/src/classes/gmaps.something_went_wrong'),
      type: 'danger'
    });
  });
};

const calculateValorKmPoliticaProjeto = (idProjeto) => {
  const km = moneyToFloat(kilometragemInput.value);

  if (!km) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: route('app.despesas.calcular-valor-km-politica-projeto'),
    dataType: 'json',
    data: { kilometragem: km, idProjeto: idProjeto }
  }).done(response => {
    valorInput.value = floatToMoney(response.data.valor.toFixed(2));
    $(valorInput).trigger('change');
    valorKmInput.value = response.data.valorKm;
    valorInput.readOnly = !response.data.permiteAlterarValorKm
    valorKmInput.readOnly = !response.data.permiteAlterarValorKm
  }).fail(response => {
    GlobalAlerts.createAndShow({
      title: Lang.get('js/src/classes/gmaps.ops'),
      message: Lang.get('js/src/classes/gmaps.something_went_wrong'),
      type: 'danger'
    });
  });
};

const handleCalc = () => {
  const inputProjeto = $(percurso).find('select.idEmpresaReembolsante').first()
  const idProjeto = inputProjeto.length ? inputProjeto.val() : null;
  if (form.hasAttribute('data-calculate-valor-km-politica-projeto')) {
    calculateValorKmPoliticaProjeto(idProjeto);
  } else if (form.hasAttribute('data-calculate-valor-km-politica')) {
    calculateValorKmPolitica();
  } else {
    calculateTotal();
  }
};

// método usado no botão de remover projeto para recalcular valor com
// valores padrão da empresa
const handleCalcProjectPolicyRemoveProject = () => {
  if (form.hasAttribute('data-calculate-valor-km-politica-projeto')) {
    calculateValorKmPoliticaProjeto(null);
  }
}

$('#modal-mapa-percurso').on('show.bs.modal', function () {
  percurso = document.getElementById('modal-mapa-percurso');
  updateInputs();
  if (!inputEventControlModalMapa) {
    CalcCourseValue();
    handleCalc();
    inputEventControlModalMapa = true;
  }
});

$('#modal-percurso').on('show.bs.modal', function () {
  percurso = document.getElementById('modal-percurso');
  updateInputs();
  if (!inputEventControlModalPercurso) {
    CalcCourseValue();
    handleCalc();
    inputEventControlModalPercurso = true;
  }
});

// funcao para atualizar os valores dos inputs
// de acordo com a modal que estiver aberta
const updateInputs = () => {
  valorKmInput = percurso.querySelector('#valorKm');
  kilometragemInput = percurso.querySelector('#kilometragem');
  valorInput = percurso.querySelector('#valor');
  dataInput = percurso.querySelector(percurso.id === 'modal-mapa-percurso' ? '#data-percurso-mapa' : '#data-percurso');
  idInput = percurso.querySelector('[name=id]');
  obsInput = percurso.querySelector('#obs');
  form = valorInput.form;
}

module.exports = {
  init: CalcCourseValue,
  handleCalc: handleCalc,
  handleCalcProjectPolicyRemoveProject: handleCalcProjectPolicyRemoveProject
};
